<template>
    <div class="container login-success">
        <login-header
            :headerConfig="headerConfig"
            @handleClickIocn="handleClickIocn"
        />
        <div class="main">
            <div class="tip-wrap">
                <success-tip :infoStyle="infoStyle" :info="info" />
            </div>

            <el-button @click="getInto">立即进入</el-button>
        </div>
    </div>
</template>

<script>
import loginHeader from "@/components/header";
import successTip from "@/components/successTip";

export default {
    name: "loginSuccess",
    components: {
        loginHeader,
        successTip,
    },
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-cuowu",
                headerTitle: "中国土木工程学会",
                color: "",
            },
            infoStyle: {
                color: "#f9000d",
            },

            info: "登录成功",
        };
    },

    methods: {
        handleClickIocn() {
            //do something
        },
        getInto() {
            this.$router.push({name: 'home', query: {from: "login"}});  
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    text-align: center;

    ::v-deep .el-button {
        position: relative;
        top: 150px;
        width: 80%;
        margin: 0 auto;
        background: var(--main-color);
        color: #fff;

        &:hover {
            color: #fff;
        }

        &:focus {
            background: var(--main-color);
            border-color: #fff;
        }
    }
}
</style>